<template>
  <Layout>
    <PageHeader :title="title" :items="items"></PageHeader>
    <!-- <WorkOrdersSearch :units="units"></WorkOrdersSearch> -->
    <!-- <WorkOrdersTable
      v-if="unitsLoaded"
      :units="units"
      :employees="employees"
    ></WorkOrdersTable> -->
    <div v-if="!unitsLoaded && childComponentLoading" class="d-flex justify-content-center align-items-center" style="height: 60vh;">
      <spring-spinner :animation-duration="3000" :size="80" :color="'blue'" />
    </div>
    <work-orders-kanban :units="units" :employees="employees" :repairs="repairs"
      :workOrders="workOrders" :parentDataLoaded="unitsLoaded" @format-repair-data-timestamps="convertRepairsTimeStampsToJSDates"
      @refresh-work-orders="refreshWorkOrders">
    </work-orders-kanban>
  </Layout>
</template>

<script>
import Layout from '../../../layouts/main';
import PageHeader from '@/components/page-header';
// import WorkOrdersTable from '../components/maintenance/workOrders/workOrdersTable.vue';
import WorkOrdersKanban from '../components/maintenance/workOrders/workOrdersKanban.vue';
// import WorkOrdersSearch from '../components/maintenance/workOrders/workOrdersSearch.vue';
import { getUnits, getEmployees, getWorkOrders, hydrateWorkOrderDoc } from '../helper/dbHelpers.js';
import { firestore } from 'firebase';
import Swal from 'sweetalert2';
import lodash from 'lodash'
import { SpringSpinner } from 'epic-spinners';

export default {
  components: {
    Layout,
    PageHeader,
    WorkOrdersKanban,
    SpringSpinner,
  },
  data() {
    return {
      title: 'Work Orders',
      items: [
        {
          text: 'home',
          href: '/',
        },
        {
          text: 'workOrders',
          href: '/production/maintenance/workOrders',
          active: true,
        },
      ],
      units: [],
      employees: [],
      repairs: [],
      workOrders: [],
      unitsLoaded: false,
      childComponentLoading: true,
      initialWorkOrdersLoaded: false
    };
  },
  methods: {
    updateLoadingState(newState) {
      this.childComponentLoading = newState;
    },
    async getUnits() {
      await getUnits()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let obj = doc.data();
            obj['UID'] = doc.id,
            this.units.push(obj);
          });
        })
        .catch((error) => {
          console.log(`Error getting units. ${error}`);
        });
    },
    getEmployees() {
      getEmployees()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let obj = {
              id: doc.id,
              name: doc.data().name,
              email: doc.data().email,
            };
            this.employees.push(obj);
          });
        })
        .catch((error) => {
          console.log(`Error getting employees. ${error}`);
        });
    },
    getWorkOrderRepairs() {
      firestore()
        .collection('workOrderRepairs')
        .where('org', '==', sessionStorage.getItem('org'))
        .where('number', '==', null)
        .orderBy('date', 'asc')
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let data = doc.data();
            data.id = doc.id;
            data.selected = false;
            data.isVisible = true;
            if (data.datesFormatted) {
              data.datesFormatted = false
            }
            this.repairs.push(data);
          });
          this.repairs = this.convertRepairsTimeStampsToJSDates(lodash.cloneDeep(this.repairs));
        })
        .catch((error) => {
          console.log(`Error getting Work Order Repairs. ${error}`);
        });
    },
    async getInitialWorkOrders() {
      // check if a work order number was passed as a paramater in the url
      let specificStartDateForQuery = null;
      if(this.$route.params.wonumber){
          // if the work order's date is older than 6 months, set the start date to the work order date
          const woDate = new Date(this.$route.params.wodate);
          let currentDate = new Date();
          let sixMonthsAgo = new Date(currentDate);
          sixMonthsAgo.setMonth(currentDate.getMonth() - 6);

          if (woDate < sixMonthsAgo) {
            specificStartDateForQuery = woDate;
          } 
      }

      await getWorkOrders(specificStartDateForQuery)
        .then((querySnapshot) => {
          const hoursEnabled = this.$store.state.custom.workOrders.repair_hours_enabled;
          const costEnabled = this.$store.state.custom.workOrders.repair_cost_enabled;
          const labourHoursEnabled = this.$store.state.custom.workOrders.labour_hours_enabled;
          querySnapshot.forEach((doc) => {
            // shape each raw doc into board form (shared with the single-WO fresh fetch)
            this.workOrders.push(
              hydrateWorkOrderDoc(doc.data(), doc.id, this.units, hoursEnabled, costEnabled, labourHoursEnabled)
            );
          });
        })
        .catch((error) => {
          Swal.fire(
            'Error!',
            'Error getting work orders. Please contact support.',
            'error'
          );
          console.log(`Error getting work orders. ${error}`);
        });
    },
    // re-pull the board (used by the kanban's Refresh Work Order flow)
    async refreshWorkOrders() {
      this.unitsLoaded = false;
      this.workOrders = [];
      this.repairs = [];
      this.getWorkOrderRepairs();
      await this.getInitialWorkOrders();
      this.unitsLoaded = true;
    },
    convertRepairsTimeStampsToJSDates(repairs, emitted = false) {
      // convert all timestamps to JS dates from the repairs data retreived from firestore
      repairs.forEach((repair) => {
        // check if the repair has had its dates formatted yet
        if (repair.date && repair.date instanceof firestore.Timestamp) {
          repair.date = repair.date.toDate()
        }
        if (repair.createdDate && repair.createdDate instanceof firestore.Timestamp) {
          repair.createdDate = repair.createdDate.toDate()
        }
        if (repair.submitted && repair.submitted.time && repair.submitted.time instanceof firestore.Timestamp) {
          repair.submitted.time = repair.submitted.time.toDate()
        }
        if (repair.completedBy && repair.completedBy.date && repair.completedBy.date instanceof firestore.Timestamp) {
          repair.completedBy.date = repair.completedBy.date.toDate()
        }
        if (repair.repairedBy && repair.repairedBy.length > 0) {
          repair.repairedBy.forEach((repBy) => {
            if (repBy.date && repBy.data instanceof firestore.Timestamp) {
              repBy.date = repBy.date.toDate()
            }
          })
        }
      })

      if(emitted){
        this.repairs = repairs;
      }

      return repairs;
    },
  },
  async mounted() {
    await this.getUnits();
    this.getEmployees();
    this.getWorkOrderRepairs();
    await this.getInitialWorkOrders();
    this.unitsLoaded = true;
  },
};
</script>
